/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
// import { GeneralInfo } from '../index';
import { Board } from '../../data/Board';

import {
    Ellipse52,
    X,
    Group48,
    Diamond,
    CancelProject,
    GoBack3Steps,
    Circle,
    RedPolygon,
    RectangleStroke,
    PolygonOrange,
    EmptyCircle,
    MilstonePolygon,
    GateCircle,
} from '../../Constants/assets';

let GameDefinitionData = Board.map((item, index) => {
    if (item.type === 'gate' && item.gate !== undefined) {
        return {
            highCost: item.gate.rates.high,
            mediumCost: item.gate.rates.medium,
            lowCost: item.gate.rates.low,
        };
    }
});

// sort out undefined objects (the map function from before returns null as default even if you don't want to return anything)
GameDefinitionData = GameDefinitionData.filter(function sort(item) {
    return item !== undefined;
});
const romanNumberArray = ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ'];
// Stylings
const Con = styled.div`
    height: 92%;
    width: 72%;
    display: flex;
    align-content: stretch;
    justify-content: space-around;
    align-items: center;
    position: absolute;
`;
const InnerContainer = styled.div`
    width: 98%;
    height: 98%;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    background: ${props => props.theme.colors.white};
    z-index: 100;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            margin-left: -1rem;
        }
    `}
`;
const HeaderContainer = styled.div``;
const TitleContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: -10px;
`;
const XContainer = styled.div`
    height: 57%;
    cursor: pointer;
`;
const Title = styled.h1`
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    width: 89%;
`;
const ParagraphContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    line-height: 21.8px;
    width: 85%;
    margin-left: -10px;
`;
const ParagraphContainerTitle = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    line-height: 21.8px;
    width: 85%;
    margin-left: -10px;
    height: 75%;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            height: 100%;
        }
    `}
`;
const Paragraph = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 19px;
    width: 89%;
    color: ${props => props.theme.colors.black};

    button {
        background: none;
        border: none;
        cursor: pointer;
        text-decoration: underline;
    }
`;
const Br = styled.div``;
const GeneralInfo = styled.div`
    height: 82%;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            height: 79%;
        }
    `}
`;
const UpperContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 22%;
`;
const SubjectContainer = styled.div`
    width: 45%;
    display: flex;
    height: 12vh;
    ${'' /* border: 2px solid blue; */}
`;
const ParagraphSubjectContainer = styled.div`
    width: 96%;
`;
const SubjectBodyContainer = styled.div`
    height: 75%;
    display: flex;
    ${'' /* border: 2px solid red; */}
`;
const ParagraphSubject = styled.p`
    font-style: normal;
    font-weight: normal;
    line-height: 19px;
    p {
        font-size: 13.5px;
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
        text-decoration: underline;
    }
    @media (max-height: 800px) {
        font-size: 14px;
    }
`;

const ParagraphSubjectGates = styled.p`
    font-style: normal;
    font-weight: normal;
    line-height: 19px;
    p {
        font-size: 13.5px;
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
        text-decoration: underline;
    }
    @media (max-height: 800px) {
        font-size: 14px;
    }

    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            max-width: 320px;
        }
    `}
`;
const Line = styled.div`
    border-bottom: 1px solid ${props => props.theme.colors.lightGray};
    width: 100%;
    height: 2%;
`;

const GateControlOne = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 32%;
`;
const GateControlTwo = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 31%;
`;
const BoxContainer = styled.div`
    height: 40%;
    width: 84%;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            width: 100%;
        }
    `}
`;
const Container = styled.div`
    display: flex;
    width: 35%;
`;
const BoxTitleContainer = styled.div`
    display: flex;
    height: 40%;
    font-size: 18px;
`;
const ControlTitleContainer = styled.div`
    display: flex;
    height: 50%;
    align-items: center;
`;
const CircleImgContainer = styled.div`
    height: 40%;
    width: 65px;
`;
const BoxTitle = styled.h2`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
`;
const BoxBodyContainer = styled.div`
    height: 75%;
`;
const LineContainer = styled.div`
    display: flex;
    height: 58%;
`;
const BoxLine = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    width: 17.5rem;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            width: 16.5rem;
        }
    `}
`;
const DiamondContainer = styled.div`
    display: block;
`;

const BottomText = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    text-decoration-line: underline;
    color: ${props => props.theme.colors.darkBlue};
    margin: 2% auto;
    cursor: pointer;
`;

export default function GeneralInfoGateControl({
    title,
    paragraph,
    toggleInfo,
    generalInfoShow,
    toggleGameDefinitions,
    gameDefinitionsStage,
    handleDefinitionsStage,
}) {
    const [stage, setStage] = useState(0);
    const { t } = useTranslation();
    if (generalInfoShow == false) return null;
    if (title === 'Gate Info' && gameDefinitionsStage == 0) {
        return (
            <Con>
                <InnerContainer>
                    <HeaderContainer style={{ height: '18%' }}>
                        <TitleContainer style={{ height: '50%' }}>
                            <Title>{t('modals.game_definitions.info_title')}</Title>
                            <XContainer>
                                <X onClick={() => toggleInfo(false)} />
                            </XContainer>
                        </TitleContainer>
                        <ParagraphContainer style={{ height: '40%' }}>
                            <Paragraph>{t('modals.game_definitions.info_text')}</Paragraph>
                        </ParagraphContainer>
                    </HeaderContainer>
                    <GeneralInfo>
                        <UpperContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <EmptyCircle />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.planned_tasks')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>
                                                {t('modals.game_definitions.elements.planned_task')}
                                            </p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <PolygonOrange />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.constraints')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>
                                                {t('modals.game_definitions.elements.constraint')}
                                            </p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                        </UpperContainer>
                        <UpperContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <Circle />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t(
                                                    'global_variables.game_elements.unplanned_tasks',
                                                )}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>
                                                {t(
                                                    'modals.game_definitions.elements.unplanned_task',
                                                )}
                                            </p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <RedPolygon />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.risks')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>{t('modals.game_definitions.elements.risk')}</p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                        </UpperContainer>
                        <UpperContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <RectangleStroke />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.delays')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>{t('modals.game_definitions.elements.delay')}</p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer />
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle />
                                        </BoxTitleContainer>
                                        <ParagraphSubject />
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                        </UpperContainer>
                        <Line />
                        <Br style={{ height: '3%' }} />
                        <UpperContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <MilstonePolygon />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.milestones')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubject>
                                            <p>
                                                {t(
                                                    'modals.game_definitions.elements.milestone.info_text',
                                                )}
                                                <button
                                                    type="button"
                                                    onClick={() => toggleGameDefinitions()}
                                                >
                                                    {t(
                                                        'modals.game_definitions.elements.milestone.link',
                                                    )}
                                                </button>
                                                {t(
                                                    'modals.game_definitions.elements.milestone.info_text2',
                                                )}
                                            </p>
                                        </ParagraphSubject>
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                            <SubjectContainer>
                                <SubjectBodyContainer>
                                    <CircleImgContainer>
                                        <GateCircle />
                                    </CircleImgContainer>
                                    <ParagraphSubjectContainer>
                                        <BoxTitleContainer>
                                            <BoxTitle>
                                                {t('global_variables.game_elements.gates')}
                                            </BoxTitle>
                                        </BoxTitleContainer>
                                        <ParagraphSubjectGates>
                                            <p>
                                                {t(
                                                    'modals.game_definitions.elements.gate.info_text',
                                                )}
                                                <button
                                                    type="button"
                                                    onClick={() => handleDefinitionsStage(1)}
                                                >
                                                    {t(
                                                        'modals.game_definitions.elements.gate.link',
                                                    )}
                                                </button>
                                            </p>
                                        </ParagraphSubjectGates>
                                        {/* <BottomText onClick={() => setStage(1)}>
                                            See more about Gate Control
                                        </BottomText> */}
                                    </ParagraphSubjectContainer>
                                </SubjectBodyContainer>
                            </SubjectContainer>
                        </UpperContainer>
                    </GeneralInfo>
                </InnerContainer>
            </Con>
        );
    }
    return (
        <Con>
            <InnerContainer>
                <HeaderContainer style={{ height: '30%' }}>
                    <TitleContainer style={{ height: '30%' }}>
                        <Title>{t('sidebar.game_menu.gate_control')}</Title>
                        <XContainer>
                            <X
                                onClick={() => {
                                    toggleInfo(false);
                                    handleDefinitionsStage(0);
                                }}
                            />{' '}
                        </XContainer>
                    </TitleContainer>
                    <ParagraphContainerTitle>
                        <Paragraph>
                            <p>
                                {t('modals.gate_control.info_text')}
                                <button type="button" onClick={() => toggleGameDefinitions()}>
                                    &nbsp;{t('modals.gate_control.link')}
                                </button>
                                {t('modals.gate_control.info_text2')}
                            </p>
                        </Paragraph>
                    </ParagraphContainerTitle>
                </HeaderContainer>
                <Br style={{ height: '5%' }} />
                <GateControlOne>
                    <Container>
                        <CircleImgContainer>
                            <Ellipse52 />
                        </CircleImgContainer>
                        <BoxContainer>
                            <ControlTitleContainer>
                                <BoxTitle>
                                    {t('modals.gate_control.go_forward.info_title')}
                                </BoxTitle>
                            </ControlTitleContainer>
                            <BoxBodyContainer>
                                {GameDefinitionData.map((current, index) => {
                                    return (
                                        <LineContainer key={index} {...current}>
                                            <BoxLine>
                                                {t('modals.gate_control.go_forward.gate')}&nbsp;
                                                {romanNumberArray[index]} &nbsp;
                                                {t('modals.gate_control.go_forward.more_than')}
                                                &nbsp;
                                                {GameDefinitionData[index].highCost}
                                            </BoxLine>
                                            <DiamondContainer>
                                                <Diamond
                                                    style={{ height: '24px', width: '24px' }}
                                                />
                                            </DiamondContainer>
                                        </LineContainer>
                                    );
                                })}
                            </BoxBodyContainer>
                        </BoxContainer>
                    </Container>
                    <Container>
                        <CircleImgContainer>
                            <Group48 />
                        </CircleImgContainer>
                        <BoxContainer>
                            <ControlTitleContainer>
                                <BoxTitle>{t('modals.gate_control.delay.info_title')}</BoxTitle>
                            </ControlTitleContainer>
                            <BoxBodyContainer>
                                {GameDefinitionData.map((current, index) => {
                                    return (
                                        <LineContainer key={index} {...current}>
                                            <BoxLine>
                                                {t('modals.gate_control.delay.gate')}&nbsp;
                                                {romanNumberArray[index]} &nbsp;
                                                {t('modals.gate_control.delay.between')} &nbsp;
                                                {GameDefinitionData[index].mediumCost}
                                                {t('modals.gate_control.delay.and')} &nbsp;
                                                {GameDefinitionData[index].highCost}
                                            </BoxLine>
                                            <DiamondContainer>
                                                <Diamond
                                                    style={{ height: '24px', width: '24px' }}
                                                />
                                            </DiamondContainer>
                                        </LineContainer>
                                    );
                                })}
                            </BoxBodyContainer>
                        </BoxContainer>
                    </Container>
                </GateControlOne>
                <GateControlTwo>
                    <Container>
                        <CircleImgContainer>
                            <GoBack3Steps />
                        </CircleImgContainer>
                        <BoxContainer>
                            <ControlTitleContainer>
                                <BoxTitle>{t('modals.gate_control.go_back.info_title')}</BoxTitle>
                            </ControlTitleContainer>
                            <BoxBodyContainer>
                                {GameDefinitionData.map((current, index) => {
                                    return (
                                        <LineContainer key={index} {...current}>
                                            <BoxLine>
                                                {t('modals.gate_control.go_back.gate')}&nbsp;
                                                {romanNumberArray[index]} &nbsp;
                                                {t('modals.gate_control.go_back.between')} &nbsp;
                                                {GameDefinitionData[index].lowCost}
                                                {t('modals.gate_control.go_back.and')} &nbsp;
                                                {GameDefinitionData[index].mediumCost}
                                            </BoxLine>
                                            <DiamondContainer>
                                                <Diamond
                                                    style={{ height: '24px', width: '24px' }}
                                                />
                                            </DiamondContainer>
                                        </LineContainer>
                                    );
                                })}
                            </BoxBodyContainer>
                        </BoxContainer>
                    </Container>
                    <Container>
                        <CircleImgContainer>
                            <CancelProject />
                        </CircleImgContainer>
                        <BoxContainer>
                            <ControlTitleContainer>
                                <BoxTitle>
                                    {t('modals.gate_control.cancel_project.info_title')}
                                </BoxTitle>
                            </ControlTitleContainer>
                            <BoxBodyContainer>
                                {GameDefinitionData.map((current, index) => {
                                    return (
                                        <LineContainer key={index} {...current}>
                                            <BoxLine>
                                                {t('modals.gate_control.cancel_project.gate')}&nbsp;
                                                {romanNumberArray[index]} &nbsp;
                                                {t('modals.gate_control.cancel_project.less_than')}
                                                &nbsp;
                                                {GameDefinitionData[index].lowCost}
                                            </BoxLine>
                                            <DiamondContainer>
                                                <Diamond
                                                    style={{ height: '24px', width: '24px' }}
                                                />
                                            </DiamondContainer>
                                        </LineContainer>
                                    );
                                })}
                            </BoxBodyContainer>
                        </BoxContainer>
                    </Container>
                </GateControlTwo>
            </InnerContainer>
        </Con>
    );
}
